import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxOtpInputConfig } from 'ngx-otp-input';
import { ToastrService } from 'ngx-toastr';
import { ConfirmpasswordComponent } from '../confirmpassword/confirmpassword.component';
import { Notification } from '../../../../core/Notifications/Notification';

import { environment } from '../../../../../environments/environment.prod';
import { Subscription, interval } from 'rxjs';
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {
  otp: any;
  id: number;
  phoneNumber: any;
  Message: string = "";
  showResendButton = false;
  countdown = 2;
  minutes = 2;
  seconds = 0;
  timerSubscription: Subscription;
  loginform: FormGroup;
  resendform: FormGroup;
  resendForm = false
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any,private fb: FormBuilder,public dialog:MatDialog,public toastr:ToastrService,  private router: Router,private Http: HttpClient, private notify: Notification) { 
    this.loginform = this.fb.group({
      'otp':[''],
      'phoneNumber': [''],
      'id': [0],
      'user_type': ['']
    })

    this.resendform = this.fb.group({
      'otp':[''],
      'phoneNumber': [''],
      'id': this.re_id,
      'user_type': ['']
      })
      
  }

  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 4,
    autofocus: true,
    classList: {
      inputBox: 'my-super-box-class',
      input: 'my-super-class',
      inputFilled: 'my-super-filled-class',
      inputDisabled: 'my-super-disable-class',
      inputSuccess: 'my-super-success-class',
      inputError: 'my-super-error-class',
    },
  };
 
  
  // handeOtpChange(value: string[]): void {
  //   console.log(value);
  // }
 
  // handleFillEvent(value: string): void {
  //   console.log(value);
  // }
  

  ngOnInit(): void {
    this.bind()
    this.rebind()
    this.phoneNumber = this._data.phoneNumber
    this.id = this._data.id
    this.otp = this._data.otp
    console.log('1st data', this._data)
    console.log('Data', this._data);
    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          this.showResendButton = true;
          this.timerSubscription.unsubscribe();
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    });
  }
  re_id:any
  resendOTP() {
    this.resendForm=true;
    var Data:any;
    this.countdown = 2;
    this.minutes = 2;
    this.seconds = 0;
    this.showResendButton = false;
    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          this.showResendButton = true;
          this.timerSubscription.unsubscribe();
          
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    });
    this.Http.get(`${environment.Login_URL}` + `api/Authentication/SendOTP_ForgotPwd/${this.loginform.value.phoneNumber}/${'1407167957139097720'}`).subscribe((data: any) => {
      console.log('Re-send Data', data);
      this.re_id = data.Id;
      //  Data = {
      //   "phoneNumber": this.loginform.value.phoneNumber,
      //   "id": this.id,
      //   "otp": ""
      // };
   
  })
}
  onSubmit() {
    var Data:any;
    // this._data.phoneNumber = this.phoneNumber;
    // this._data.id = this.id;
    // this._data.otp = this.otp;
    // const formData = {
    //   otp: this.loginform.value.otp, // Make sure 'otp' matches the formControlName in your HTML template
    //   phoneNumber: this.phoneNumber,
    //   "id": this.id,
    // };
    if (!this.loginform.value.otp) {
      this.toastr.error('Please enter the OTP.', 'Error');
      return;
    }
    this.Http.post(`${environment.Login_URL}` + `api/Authentication/VerifyOTP_ForgotPwd`, this.loginform.value).subscribe((data:any) => {
      console.log('Data1', Data);
      Data = {
        "phoneNumber": this.loginform.value.phoneNumber,
        "id": this.id, 
        "otp": "",
        "user_type": "patient"
      };
      this.openDialog(this.loginform.value)

    },
    //  (error)=> {
    //   console.log('Error', error);
    //   alert("error")
    //   //this.notify.errorsmsg(Data.Message);
    //   window.location.reload();
    // }
    )
}


reSubmit() {

  // this._data.phoneNumber = this.phoneNumber;
  // console.log('Data is found', this.resendform.value.id);
  // console.log('Re_id', this.re_id);
  // let Data = {
  // "phoneNumber": this.resendform.value.phoneNumber,
  // "id": this.re_id,
  // "otp": this.resendform.value.otp
  // };
  // console.log('Re_id', Data);
 
  // this.Http.post(`${environment.Login_URL}` + `api/Authentication/VerifyOTP_ForgotPwd`, this.resendform.value).subscribe((data:any) => {
  // console.log('Data is re-found', data);
  // this.openDialog(Data)
  // })
  var Data:any;
  // this._data.phoneNumber = this.phoneNumber;
  // this._data.id = this.id;
  // this._data.otp = this.otp;
  // const formData = {
  //   otp: this.loginform.value.otp, // Make sure 'otp' matches the formControlName in your HTML template
  //   phoneNumber: this.phoneNumber,
  //   "id": this.id,
  // };
  if (!this.resendform.value.otp) {
    this.toastr.error('Please enter the OTP.', 'Error');
    return;
  }
  Data = {
    "phoneNumber": this.resendform.value.phoneNumber,
    "id": this.re_id, 
    "otp": this.resendform.value.otp,
    "user_type": "patient"
  };
  this.Http.post(`${environment.Login_URL}` + `api/Authentication/VerifyOTP_ForgotPwd`, Data).subscribe((data:any) => {
    console.log('Data1', Data);
   
    this.openDialog(Data)

  },
  //  (error)=> {
  //   console.log('Error', error);
  //   alert("error")
  //   //this.notify.errorsmsg(Data.Message);
  //   window.location.reload();
  // }
  )
 }
openDialog(apiResponse: any) {
  const dialogRef = this.dialog.open(ConfirmpasswordComponent, {
    height: '100%',
    width: '100%',
    maxWidth: '100%',
    disableClose: true,
    data: apiResponse
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('Dialog was closed with result:', result);
  });
}


bind(){
  console.log('1st bind', this._data)
  this.loginform.controls['otp'].setValue(this._data.otp)
  this.loginform.controls['phoneNumber'].setValue(this._data.phoneNumber)
  this.loginform.controls['id'].setValue(this._data.id)
  this.loginform.controls['user_type'].setValue("patient")
}

rebind(){
  console.log('1st rebind', this._data)
  this.resendform.controls['otp'].setValue(this._data.otp)
  this.resendform.controls['phoneNumber'].setValue(this._data.phoneNumber)
  this.resendform.controls['id'].setValue(this._data.re_id) 
  this.resendform.controls['user_type'].setValue("patient") 
 }
}
